import Vue from 'vue'
import Router from 'vue-router'
import technology from '@/components/technology';
import index from '@/components/index';
import about from '@/components/about';
import devolop from '@/components/devolop';
import join from '@/components/join';
import solution from '@/components/solution';
import product from '@/components/product';
import product1 from '@/components/product1';
import product2 from '@/components/product2';
import product3 from '@/components/product3';
import solution1 from '@/components/solution1';
import solution2 from '@/components/solution2';
import download from '@/components/download';
import software from '@/components/software';



Vue.use(Router)
const router = new Router({
  // mode:'history',
  // hashbang:false,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta:{
        title:"威尔云VRVIU - 全球领先的高清视频云服务",
        description:"威尔云是全球领先的VR高清直播云服务，支持高清4K/6K/8K的低带宽、低延迟，多终端、多场景的推流播放，并能为您节省70%带宽成本。",
        title_en:"VRVIU - The Highway to Ultra HD",
        description_en:"VRVIU Cloud provides the world’s leading high-definition VR live service, and helps you save 70% bandwidth cost."
      }
    },
    {
      path: '/technology',
      name: 'technology',
      component: technology,
      meta:{
        title:"核心技术 - 威尔云 VRVIU",
        description:"威尔云 · 创建VR高速公路；挑战高清极限：4K，6K，8K；上行带宽节省70%，下行带宽节省70%；超低视角切换延迟；智能编解码；专利音频编解码…",
        title_en:"Technology - VRVIU",
        description_en:"Higher resolution 4K/6K/8K at 70% less upload/download bandwidth cost. Supports stable 24/7 high concurrent streaming, intelligent codec and 3D sound in VR."
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
      meta:{
        title:"关于我们 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:'About Us - VRVIU',
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."

      }
    },
    {
      path: '/devolop',
      name: 'devolop',
      component: devolop,
      meta:{
        title:"SDK - 威尔云 VRVIU",
        description:"7x24小时稳定直播；高性能，低消耗；秒开，流畅切换；多开发环境…",
        title_en:"SDK - VRVIU",
        description_en:"Providing instant start-up, smooth playback, and cross-platform SDK."
      }
    },
    {
      path: '/software',
      name: 'software',
      component: software,
      meta:{
        title:"Software - 威尔云 VRVIU",
        description:"7x24小时稳定直播；高性能，低消耗；秒开，流畅切换；多开发环境…",
        title_en:"Software - VRVIU",
        description_en:"Providing instant start-up, smooth playback, and cross-platform SDK."
      }
    },
    {
      path: '/join',
      name: 'join',
      component: join,
      meta:{
        title:"加入我们 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:"Join Us - VRVIU",
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
      }
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      meta:{
        title:"产品 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:"Product - VRVIU",
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
      }
    },
    {
      path: '/product1',
      name: 'product1',
      component: product1,
      meta:{
        title:"产品 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:"Product - VRVIU",
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
      }
    },
    {
      path: '/product2',
      name: 'product2',
      component: product2,
      meta:{
        title:"产品 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:"Product - VRVIU",
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
      }
    },
    {
      path: '/product3',
      name: 'product3',
      component: product3,
      meta:{
        title:"产品 - 威尔云 VRVIU",
        description:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下享受到身临其境的VR体验。",
        title_en:"Product - VRVIU",
        description_en:"VRVIU brings bandwidth-hungry video to the global mass market while overcoming current internet infrastructure constraints."
      }
    },
    {
      path: '/solution',
      name: 'solution',
      component: solution,
      meta:{
        title:"解决方案 - 威尔云 VRVIU",
        description:"180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
        title_en:"Solutions - VRVIU",
        description_en:"180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
      }
    },
    {
      path: '/solution1',
      name: 'solution1',
      component: solution1,
      meta:{
        title:"解决方案 - 威尔云 VRVIU",
        description:"180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
        title_en:"Solutions - VRVIU",
        description_en:"180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
      }
    },
    {
      path: '/solution2',
      name: 'solution2',
      component: solution2,
      meta:{
        title:"解决方案 - 威尔云 VRVIU",
        description:"180° 3D：2M带宽看4K，360°全景：视角切换延迟零延迟，威尔云6大特性，多平台适配。",
        title_en:"Solutions - VRVIU",
        description_en:"180° 3D: 4K quality at 2Mbps, 360° VR: zero-perceived view switching latency."
      }
    },
    {
      path: '/download',
      name: 'download',
      component: download,
      meta:{
        title:"下载Demo - 威尔云 VRVIU",
        description:"下载即可体验威尔云技术处理后，多种VR场景下(包括秀场、游戏、体育）适用的视频。",
        title_en:"Download - VRVIU",
        description_en:"Experience our quality 4K streaming in sporting concerts, and eSports through our demo."
      }
    }
  ]
})

function setTitle(t) {
    document.title = t;
    var i = document.createElement('iframe');
    i.src = '//m.baidu.com/favicon.ico';
    i.style.display = 'none';
    i.onload = function() {
        setTimeout(function() {
            i.remove();
        }, 9)
    }
    document.body.appendChild(i);
}
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0; 
  if(localStorage.locale){
    if(localStorage.locale=="en"){
      setTitle(to.meta.title_en)
    }else{
      setTitle(to.meta.title)
    }

  }else{
    var language = navigator.language; //取得浏览器版本语言
    // var initLanguage = "";
    if (language.indexOf('zh') > -1){
      // initLanguage="ch"; //中文页面
      setTitle(to.meta.title)
    }else if (language.indexOf('en') > -1){
      // initLanguage="en"; //英文页面
      setTitle(to.meta.title_en)
    }
  }

  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js